import { DataRow } from "./StagingHistoryContainer";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import { TableColumnsType } from "antd";
import { ExpandableConfig } from "antd/es/table/interface";
import { TransferRecorderHistoryItem } from "api/interfaces/recorderInterface.interface";
type Props = {
  columns: TableColumnsType<TransferRecorderHistoryItem>;
  data: Array<TransferRecorderHistoryItem>;
  paginationInfo: BasePagination;
  onChangePage: (page: number, totalRows: number) => void;
  initialPending: boolean;
  // expandableProps?: ExpandableConfig<DataRow>;
};

export default function StagingHistoryPresenter({
  columns,
  data = [],
  paginationInfo,
  onChangePage,
  initialPending,
  // expandableProps,
}: Props): JSX.Element {
  return (
    <ExpandTableContainer>
      <CommonTable
        columns={columns}
        dataSource={data}
        queryInfo={paginationInfo}
        onChangePage={onChangePage}
        loading={initialPending}
        // expandable={expandableProps}
        rowClassName="noPointer"
      />
    </ExpandTableContainer>
  );
}
